<template>
  <div />
</template>
<script>

  export default {
    name: 'Logout',
    async created () {
      this.$auth.logout()
    },
  }
</script>
